import useGetUser from '../hooks/useGetUser';
import { useTranslation } from 'react-i18next';
import UserForm from '../components/UserForm';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import UserPasswordForm from './UserPasswordForm';
import UserFeedbackForm from './UserFeedbackForm';
import { Separator } from '@/components/ui/separator';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import useLogout from '../hooks/useLogout';
import { useNavigate } from 'react-router-dom';
import { UserDarkModeToggle } from '../components/UserDarkModeToggle';
import UserDeleteButton from '../components/UserDeleteButton';

const Profile = () => {
	const { t } = useTranslation();
	const { user } = useGetUser();

	const navigate = useNavigate();

	const { logout } = useLogout();

	if (!user) return null;

	return (
		<div className="w-full ">
			<div className="flex justify-between">
				<span className="text-2xl font-bold">{t('profile.title')}</span>
				<UserDarkModeToggle />
			</div>
			<div className="mt-4 flex flex-col gap-3 pb-24 sm:flex-row sm:flex-wrap">
				<Card className="sm:flex-auto">
					<CardHeader>
						<CardTitle className="text-lg">
							{t('profile.edit.title')}
						</CardTitle>
						<Separator />
					</CardHeader>
					<CardContent>
						<UserForm />
					</CardContent>
				</Card>

				<Card className="sm:w-1/2">
					<CardHeader>
						<CardTitle className="text-lg">
							{t('profile.password.title')}
						</CardTitle>
						<Separator />
					</CardHeader>
					<CardContent>
						<UserPasswordForm />
					</CardContent>
				</Card>

				<Card className="sm:w-full">
					<CardHeader>
						<CardTitle className="text-lg">
							{t('profile.feedback.title')}
						</CardTitle>
						<Separator />
					</CardHeader>
					<CardContent>
						<UserFeedbackForm />
					</CardContent>
				</Card>

				<Card className="sm:w-96">
					<CardHeader>
						<CardTitle className="text-lg">
							{t('profile.disconnect.title')}
						</CardTitle>
						<Separator />
					</CardHeader>
					<CardContent>
						<Button
							className="w-full"
							onClick={() => {
								logout(undefined, {
									onSettled: () => navigate('/'),
								});
							}}
						>
							<LogOut className="mr-2 h-4 w-4" />
							{t('profile.disconnect.action')}
						</Button>
					</CardContent>
				</Card>

				<Card className="sm:w-96">
					<CardHeader>
						<CardTitle className="text-lg">
							{t('profile.delete.title')}
						</CardTitle>
						<Separator />
					</CardHeader>
					<CardContent>
						<UserDeleteButton />
					</CardContent>
				</Card>
			</div>
		</div>
	);
};

export default Profile;
